// extracted by mini-css-extract-plugin
export default {"divMessage":"MessageError_divMessage__NJIuz","divMessage__message":"MessageError_divMessage__message__MOwwQ"};